<template>
  <div class="banner-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>轮播图管理（banners）</span>
        <div>
          <el-button type="primary" size="small" @click="handleCreate">新增轮播图</el-button>
        </div>
      </div>

      <el-form :inline="true" :model="query" class="filter-form">
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="按标题搜索" clearable size="small" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable size="small">
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="fetchList(1)">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="imgurl" label="图片" width="160">
          <template slot-scope="scope">
            <el-image :src="scope.row.imgurl" style="width: 120px; height: 60px" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="120" />
        <el-table-column prop="type" label="类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" size="small">普通</el-tag>
            <el-tag v-else-if="scope.row.type === 2" type="success" size="small">可点击</el-tag>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" label="排序号" width="90" />
        <el-table-column prop="link_type" label="跳转类型" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.link_type === 0">无</span>
            <span v-else-if="scope.row.link_type === 1">商品</span>
            <span v-else-if="scope.row.link_type === 2">外链</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleToggleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :current-page.sync="page"
          :total="total"
          @current-change="fetchList"
        />
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="图片" prop="imgurl">
          <el-upload
            class="banner-uploader"
            action="/api/common/upload"
            :data="{ folder: '二手' }"
            :show-file-list="false"
            accept="image/*"
            :before-upload="beforeUpload"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
          >
            <img v-if="form.imgurl" :src="form.imgurl" class="banner-image" />
            <i v-else class="el-icon-plus banner-upload-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="用于前端展示的标题" />
        </el-form-item>
        
        <el-form-item label="排序号" prop="order_no">
          <el-input-number v-model="form.order_no" :min="0" />
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

function formatDateArray (arr) {
  if (!Array.isArray(arr) || arr.length < 6) return ''
  const [y, M, d, h, m, s] = arr
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${y}-${pad(M)}-${pad(d)} ${pad(h)}:${pad(m)}:${pad(s)}`
}

function toViewBanner (b) {
  return {
    id: b.id,
    imgurl: b.imgurl,
    title: b.title,
    type: b.type,
    order_no: b.orderNo != null ? b.orderNo : b.order_no,
    link_type: b.linkType != null ? b.linkType : b.link_type,
    link_url: b.linkUrl != null ? b.linkUrl : b.link_url,
    param: b.param,
    status: b.status,
    created_at: Array.isArray(b.createdAt) ? formatDateArray(b.createdAt) : (b.created_at || b.createdAt || '')
  }
}

function toDtoBanner (f) {
  return {
    imgurl: f.imgurl,
    title: f.title,
    type: f.type,
    orderNo: f.order_no,
    linkType: f.link_type,
    linkUrl: f.link_url,
    param: f.param,
    status: f.status
  }
}

export default {
  name: 'BannerManage',
  data () {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      query: {
        title: '',
        status: null
      },
      dialogVisible: false,
      dialogTitle: '新增轮播图',
      form: {
        id: null,
        imgurl: '',
        title: '',
        type: 1,
        order_no: 0,
        link_type: 0,
        link_url: '',
        param: '',
        status: 1
      },
      rules: {
        imgurl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    beforeUpload (file) {
      const isImg = file && file.type && file.type.startsWith('image/')
      if (!isImg) {
        this.$message.error('仅支持上传图片文件')
        return false
      }
      return true
    },
    handleUploadSuccess (response) {
      let url = ''
      if (response && typeof response === 'object') {
        const isSuccess = response.code === 0 || response.code === 1
        if (isSuccess && response.data) {
          url = response.data
        } else if (!isSuccess) {
          this.$message.error(response.message || response.msg || '文件上传失败')
          return
        }
      }
      if (!url && response && typeof response === 'string') {
        url = response
      }
      if (typeof url === 'string') {
        url = url.trim().replace(/`/g, '')
      }
      if (url) {
        this.form.imgurl = url
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.validateField('imgurl')
        })
      } else {
        this.$message.error('文件上传失败')
      }
    },
    handleUploadError () {
      this.$message.error('文件上传失败')
    },
    async fetchList (page = this.page) {
      this.page = page
      this.loading = true
      try {
        const res = await http.get('/api/admin/banners/page', {
          params: {
            page: this.page,
            pageSize: this.pageSize,
            title: this.query.title || undefined,
            status: this.query.status == null ? undefined : this.query.status
          }
        })
        let items = []
        let total = 0
        if (Array.isArray(res)) {
          items = res
          total = res.length
        } else if (res) {
          const candidates = res.items || res.records || res.list || res.rows || []
          items = Array.isArray(candidates) ? candidates : []
          total = res.total != null ? res.total : (res.totalCount != null ? res.totalCount : (res.count != null ? res.count : items.length))
        }
        this.list = items.map(toViewBanner)
        this.total = total
      } catch (e) {
        this.$message.error(e.message || '获取轮播图列表失败')
      } finally {
        this.loading = false
      }
    },
    resetQuery () {
      this.query.title = ''
      this.query.status = null
      this.fetchList(1)
    },
    handleCreate () {
      this.dialogTitle = '新增轮播图'
      this.dialogVisible = true
      this.form = {
        id: null,
        imgurl: '',
        title: '',
        type: 1,
        order_no: 0,
        link_type: 0,
        link_url: '',
        param: '',
        status: 1
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleEdit (row) {
      this.dialogTitle = '编辑轮播图'
      this.dialogVisible = true
      this.form = Object.assign({}, row)
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleSubmit () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          const dto = toDtoBanner(this.form)
          if (this.form.id) {
            await http.put(`/api/admin/banners/${this.form.id}`, dto)
          } else {
            await http.post('/api/admin/banners', dto)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        }
      })
    },
    handleDelete (row) {
      this.$confirm(`确认删除轮播图「${row.title}」吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await http.delete(`/api/admin/banners/${row.id}`)
          this.$message.success('删除成功')
          this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '删除失败')
        }
      }).catch(() => {})
    },
    handleToggleStatus (row) {
      const target = row.status === 1 ? 0 : 1
      const text = target === 1 ? '启用' : '禁用'
      this.$confirm(`确认${text}该轮播图吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const dto = toDtoBanner({ ...row, status: target })
          await http.put(`/api/admin/banners/${row.id}`, dto)
          this.$message.success(`${text}成功`)
          this.fetchList()
        } catch (e) {
          this.$message.error(e.message || `${text}失败`)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.banner-manage {
  min-height: 300px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 10px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
.banner-uploader {
  width: 240px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  display: inline-block;
}
.banner-image {
  width: 240px;
  height: 120px;
  object-fit: cover;
  display: block;
}
.banner-upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 240px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
